<script setup>
import LoginDialog from "../lib/login/LoginDialog.vue";
import Popup from "../lib/components/Popup.vue";
import { ref } from "vue";

const menu = ref(false);
</script>

<template>
	<nav>
		<RouterLink v-if="$route.name !== 'home'" :to="{ name: 'home' }"><img class="icon-arrow-left"></RouterLink>
		<h1>{{ $route.meta.title }}</h1>
		<button class="ui icon menu" @click="menu = true"><img class="icon-bars"></button>
		<Popup v-if="menu" class="menu" @close="menu = false">
			<RouterLink :to="{ name: 'profile' }">Min Profil</RouterLink>
			<a href="/help" target="_blank">Hjelp</a>
			<a href="/">Forside</a>
			<a href="/logout">Logg ut</a>
		</Popup>
	</nav>
	<RouterView/>
	<LoginDialog/>
</template>
